module.exports = __webpack_public_path__ + "img/avatar.67b47b4f.svg";